import { parseDefault } from './utils';

const defaults = {
  default: value => value,
  colors: value => parseDefault(value),
};

export { defaults };

